import * as React from "react";
import { AllergensProvider } from "./src/context/allergensContext";
import { MenuDataProvider } from "./src/context/menuDataContext";

export const wrapPageElement = ({ element }) => (
	<MenuDataProvider>
		<AllergensProvider>{element}</AllergensProvider>
	</MenuDataProvider>
);
